module.exports = __webpack_public_path__ + "static/media/how_ar.4550b6cc.vtt";